export const ENTITY_NAME = "CommercialTerms_";
export const COMMERCIAL_TERMS_RULE = "COMMERCIAL_TERMS_RULE";
export const CONTRACT_COMMERCIAL_TERMS = "CONTRACT_COMMERCIAL_TERMS";
export const SET_TAB_FIN = "SET_TAB_FIN";